import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalTemplateComponent } from '../../../components/common/modal-template/modal-template.component';
import { ModalTemplate } from '../../../models/common-model';
import { FormsModule } from '@angular/forms';
import { OFFICE_SELECTION, TEXT_COMMON, TEXT_LOGIN } from '../../../constants/text';
import { TextButtonComponent } from "../../common/text-button/text-button.component";
import { ButtonType } from '../../../enum/common-enum';
import { Router } from '@angular/router';
import { ProcessLoadingService } from '../../../services/loading.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { OfficeService } from '../../../services/office.service';
import { ROUTE_PATH } from '../../../constants/route-path';
import { LoginHelper } from '../../../_helper/login.helper';
import { MapService } from '../../../services/map.service';
import { SessionStorageKey } from '../../../constants/session-storage-key';
import { FloorInfoService } from '../../../services/floorinfo.service';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ModalTemplateComponent,
    FormsModule,
    TextButtonComponent
],
  selector: 'careposi-dialog-office-secletion',
  templateUrl: './dialog-office-selection.component.html',
  styleUrls: ['./dialog-office-selection.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class DialogOfficeSelectionComponent implements OnInit {

  @Input() isDisplayModal: boolean = false;
  @Input() modalData: ModalTemplate = new ModalTemplate();
  @Output() onSubmitData: any = new EventEmitter<any>();


  TEXT_LOGIN = TEXT_LOGIN;
  OFFICE_SELECTION = OFFICE_SELECTION;
  officeList: any[] | null = null;
  officeSelected: any;
  hasErr: boolean = false;
  buttonType = ButtonType;
  cssDisable = 'office-disable';
  errBack = '';

  errorMessage: any = { nameErrMess: '', staytimeErrMess: '', staffErrMess: '' };
  constructor(
    private authService: AuthenticationService,
    private officeService: OfficeService,
    private router: Router,
    private pageLoadingService: ProcessLoadingService,
    private mapService: MapService,
    private floorInfoService: FloorInfoService,
  ) {

  }
  ngOnInit(): void {
    this.bindData();
  }

  bindData(){
    try { 
      this.officeList = JSON.parse(sessionStorage.getItem(SessionStorageKey.OFFICES) || '[]')
      this.officeSelected = JSON.parse(sessionStorage.getItem(SessionStorageKey.OFFICE_SELECTED) || '{}')
    } 
    catch { this.officeList = [] }
    this.officeList?.forEach(x => {
      x.disable = false;
      if(x.officecd == this.officeSelected.officecd) x.disable = true;
    })
  }

  onClose() {
    this.resetErrMess();
    this.onSubmitData.emit(null);
  }

  async onChoose(office: any, check: boolean) {
    this.pageLoadingService.showLoading();
    const userInfo = this.authService.getCurrentUserValue();
    const orgID = this.authService.getOrgId();
    const companyID = this.authService.getCompanyId();
    if (!userInfo || !orgID || !companyID) this.router.navigate([ROUTE_PATH.LOGIN]);
    else{ 
      this.authService.setprevUr(window.location.pathname?.replace('/', ''));
      await LoginHelper.loginOffice(this.authService,this.officeService, this.mapService, this.router, userInfo, office, true, this.floorInfoService);
      try { 
        this.officeSelected = JSON.parse(sessionStorage.getItem(SessionStorageKey.OFFICE_SELECTED) || '{}');
        this.officeList?.forEach(x => {
          x.disable = false;
          if(x.officecd == this.officeSelected.officecd) x.disable = true;
        });
      } 
      catch { this.officeList = [] }
    }
    this.pageLoadingService.hideLoading();
  }
  
  resetErrMess(){ this.errorMessage = { nameErrMess: '', staytimeErrMess: '', staffErrMess: '' } }

  onBack(){
    this.errBack = '';
    const orgs = JSON.parse(sessionStorage.getItem(SessionStorageKey.ORGANIZATION) || '[]');
    if(orgs.length > 0) this.router.navigate([ROUTE_PATH.CHOOSE_ORG]);
    else this.errBack = TEXT_COMMON.ERR_MESSAGE_BACK_ORG;
  }
}
